import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import { errorMessage, NormalMessage, successMessage } from "../../utils/alertMessage";
import { formatDate } from "../../constants/FormateDate";
import { DeleteLeadData, getLead, getLeadSummary, getMasterLeadStatus, getUserLead, getUserLeadSummary } from "../../services/leads";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../utils/localStorage";
import { replaceUnderscoresWithSpacesAndUpperCase } from "../../components/Regex";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";
import { getUser } from "../../services/userMasterUser";
import { MCubeCall } from "../../services/MCubeCall";

export default function DeleteLeadList() {

  const navigate = useNavigate();

  const ds = useRef(null);

  const location = useLocation();
  const isFirstRender = useRef(true);

  const { userProfileData } = getUserData();

  const [products, setProducts] = useState([]);

  let dataLimitValue = localStorage.getItem("dataLimit") || 500;
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(dataLimitValue);
  const [loadingMore, setLoadingMore] = useState(false);

  const [leadStatusList, setLeadStatusList] = useState([])

  const statusListFun = (list = []) => {
    return list.reduce((map, status) => {
      map[status] = {
        count: 0,
        totalAmount: 0,
        leadStatus: status,
      };
      return map;
    }, {});
  };

  const [statusMap, setStatusMap] = useState({});

  const [selectedProducts, setSelectedProducts] = useState(null);


  // const [statusMap, setStatusMap] = useState(statusListFun())

  const [startDate, setStartDate] = useState(new Date(localStorage.getItem("startDateFilter")));
  const [endDate, setEndDate] = useState(new Date(localStorage.getItem("endDateFilter")));

  const [pagesBoxField, setPagesBoxField] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [defaultPayload, setDefaultPayload] = useState({})

  const [showTodayFollowup, setShowTodayFollowup] = useState(false);

  const [recordTypeValue, setRecordTypeValue] = useState("CreatedOn")
  const [userDataFilter, setUserDataFilter] = useState("");
  const [userDataFilterInfo, setUserDataFilterInfo] = useState({});
  const [userDataIds, setUserDataIds] = useState([]);
  const [userDataId, setUserDataId] = useState([]);

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: dataLimitValue,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    sourceIn: [],

    recordType: recordTypeValue,
    startDate: startDate,
    endDate: endDate,
    leadTypeIn: [],
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;
          setProducts(rawData);
          setShowTodayFollowup(false);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };


  const boxFieldData = {
    leadTypeIn: [],
    recordType: "CreatedOn",
    startDate: startDate,
    endDate: endDate,
  };


  const fetchBoxFieldData = (data) => {

    getLeadSummary(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;
          rawData.reduce((map, item) => {
            setStatusMap(prev => ({
              ...prev,
              [item.leadStatus]: {
                ...prev[item.leadStatus],
                count: item.count,
                totalAmount: item.totalAmount
              }
            }));
          }, {});


        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
      });
  };

  const initialAPICall = () => {
    const leadStatusApiData = {
      leadTypeIn: [],
      roleIn: [],
      statusIn: [],
      activeOnly: "yes"
    };


    getMasterLeadStatus(leadStatusApiData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data;

          const newLeadStatusData = [
            ...new Set(
              newData
                .map(item => item?.status?.trim()) // Remove leading/trailing spaces
                .filter(Boolean) // Remove null, undefined, empty strings
            )
          ];

          setLeadStatusList(newLeadStatusData);
          setStatusMap(statusListFun(newLeadStatusData));

          fetchBoxFieldData({
            ...boxFieldData,
            statusIn: newLeadStatusData,
          });
        }
      });


  }

  useEffect(() => {

    initialAPICall()

    if (location.state?.listState) {
      const { products, first, rows, selectedType, pagesBoxField } = location.state.listState;
      setProducts(products);
      setFirst(first);
      setRows(rows);
      setSelectedType(selectedType)
      setSelectedStatus(selectedType)
      setPagesBoxField(pagesBoxField)
    } else {
      // fetchData({
      //   ...typeData,
      //   limit: rows,
      //   offset: 0
      // });
    }

  }, []);


  const handleReceiveData = (leadStatus, totalCount, payload) => {
    setSelectedType(leadStatus)
    setPagesBoxField(0);
    setDefaultPayload({
      ...payload,
      statusIn: [leadStatus]
    })
    let pages = Math.ceil(totalCount / dataLimitValue);

    setPagesBoxField(pages);
    if (pages > 0) {
      handlePageChange(0, {
        ...payload,
        statusIn: [leadStatus]
      },)
    }
  };

  const handlePageChange = (pageNumber, defaultPayload) => {
    const newOffset = pageNumber * rows;

    fetchData(
      {
        ...defaultPayload,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  const OrderStatusColors = [
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#000",
  ];

  function formatIndianShort(value) {
    if (value == null || isNaN(value)) return "";

    const num = Number(value);

    if (num >= 10000000) {
      return (num / 10000000).toFixed(num % 10000000 === 0 ? 0 : 1) + "Cr";
    }

    if (num >= 100000) {
      return (num / 100000).toFixed(num % 100000 === 0 ? 0 : 1) + "L";
    }

    return num.toLocaleString("en-IN");
  }
  // 1. Add this state near your other useState declarations
  const [selectedStatus, setSelectedStatus] = useState(null);

  const DeleteLead = () => {

    const leadDeleteData = {
      leadIds: selectedProducts?.map(item => item?.lead?.id),
      statusIn: [selectedStatus]
    }

    DeleteLeadData(leadDeleteData)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          initialAPICall()
          successMessage("Lead Delete Successfully " + Res.message);

        } else {
          errorMessage("Lead Delete Failed " + Res.message);
          initialAPICall()
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Lead Delete Failed");

      });
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <h5 className="card-title flex">
                    <div
                      className="mr-3 cursor-pointer"
                      onClick={() => navigate("/")}
                    >
                      <i class="bi bi-arrow-left-circle-fill"></i>
                    </div> Delete Data

                  </h5>
                  {selectedProducts?.length > 0 &&
                    <div className="mb-2">
                      <button type="button" onClick={() => DeleteLead()} className="move-btn move-btn-blue">
                        Delete
                      </button>
                    </div>}
                </div>

                <div className="kpi-row-forth">
                  {selectedStatus && (
                    <div
                      className="kpi"
                      style={{ borderLeftColor: "#999", cursor: "pointer", opacity: 0.7 }}
                      onClick={() => {
                        setSelectedStatus(null);
                        setShowTodayFollowup(false);
                        setProducts([])
                        setPagesBoxField(0);
                      }}
                    >
                      <div className="kpi-lbl">✕ Clear filter</div>
                      <div className="kpi-val">Show all</div>
                    </div>
                  )}

                  {Object.values(statusMap).map((leadItem, index) => (
                    <div
                      className="kpi"
                      style={{
                        borderLeftColor: OrderStatusColors[index],
                        cursor: "pointer",
                        outline: selectedStatus === leadItem.leadStatus
                          ? `2px solid ${OrderStatusColors[index]}`
                          : "none",
                        opacity: selectedStatus && selectedStatus !== leadItem.leadStatus ? 0.45 : 1,
                        transition: "opacity 0.2s, outline 0.2s",
                      }}
                      onClick={() => {
                        if (leadItem.count > 0) {
                          setShowTodayFollowup(false);


                          handleReceiveData(leadItem.leadStatus, leadItem.count, typeData);

                          setSelectedStatus(prev =>
                            prev === leadItem.leadStatus ? null : leadItem.leadStatus
                          );
                        }
                      }}
                    >
                      <div className="kpi-lbl">{leadItem.leadStatus === "hold for follow up after sometime" ? "WIP (More Then 1 Cr)" : leadItem.leadStatus} - <span style={{ fontSize: 14, color: "#3b6eef" }}>{leadItem.count}</span></div>
                      <div className="kpi-val">₹{formatIndianShort(leadItem.totalAmount)}</div>
                    </div>
                  ))}
                </div>


                <div class="sec-hdr">
                  <div class="sec-ico">
                    📥
                  </div>
                  <div>
                    <div class="sec-title">{userDataFilterInfo[0]?.label}</div>
                  </div>
                </div>

                <div className="dataview-demo">
                  <div className="card leadList">
                    {pagesBoxField > 0 && <DataTable
                      value={products}
                      // lazy
                      dataKey="lead.id"
                      scrollable
                      scrollHeight="400px"
                      first={first}   // ✅ THIS FIXES YOUR ISSUE
                      onPage={(e) => setFirst(e.first)} // ✅ also required

                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"

                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      stripedRows
                      selectionMode="multiple"
                      selection={selectedProducts}
                      onSelectionChange={(e) => {
                        if (!selectedStatus) {
                          return; // ❌ block selection
                        }
                        setSelectedProducts(e.value);
                      }}
                    >
                      {selectedStatus && <Column
                        selectionMode="multiple"
                        header={() => null}
                        headerStyle={{ width: '3rem' }}
                        className="product-category table-design"
                        body={(rowData) => {
                          return (
                            <input
                              type="checkbox"
                              checked={selectedProducts?.some(p => p.lead.id === rowData.lead.id)}
                              disabled={!selectedStatus}   // ✅ disable checkbox
                              readOnly
                            />
                          );
                        }}
                      />}
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>

                      <Column
                        field="View"
                        header="Action"
                        className="product-category table-design"
                        body={(rowData) => (
                          <div className="action-cell">

                            <Link
                              title="Lead Working Status"
                              to={"/user-lead-info-delete-data"}
                              state={{
                                rowData,
                                listState: {
                                  products,
                                  first,
                                  rows,
                                  selectedType,
                                  pagesBoxField
                                }
                              }}
                              className="act-btn act-edit"
                            >
                              <i className="bi bi-eye"></i>
                            </Link>
                          </div>
                        )}
                      ></Column>

                      {/*<Column
                                                                   field="loanFile"
                                                                   header="Loan File"
                                                                   className="product-category table-design"
                                                                   body={(rowData) => (
                                                                     <Link
                                                                       to={"/view-loan-file"}
                                                                       state={rowData?.lead}
                                                                       className="move-btn-medium move-btn-green center-text"
                                                                     >
                                                                       Loan File <i className="bi bi-eye"></i>
                                                                     </Link>
                                                                   )}
                                                                 ></Column>*/}
                      {/*<Column
                                                                                           field="status"
                                                                                           header="Status"
                                                                                           style={{ minWidth: '100px' }}
                                                                                           className="product-category table-design"
                                                                                           body={(rowData) => (
                                                                                               <span className="colored_with_bg1">
                                                                                                   {(rowData?.status)}
                                                                                               </span>
                                                                                           )}
                                                                                       ></Column>*/}
                      <Column
                        field="dateOfLead"
                        header="Date Of Lead"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored3">
                            {formatDate(rowData.lead?.dateOfLead)}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="name"
                        header="Name"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored4">
                            {rowData?.lead?.name}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="mobileNo"
                        header="Mobile No"
                        style={{ minWidth: '120px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored5">
                            {rowData.lead?.mobileNo}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="typeOfLead"
                        header="Type Of Lead"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored_with_bg2">
                            {rowData?.lead?.typeOfLead ? replaceUnderscoresWithSpacesAndUpperCase(rowData?.lead?.typeOfLead) : ""}

                          </span>
                        )}
                      ></Column>
                      <Column
                        field="amount"
                        header="Amount"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored1">
                            {rowData.lead?.amount?.toLocaleString("en-IN")}
                          </span>
                        )}
                      ></Column>
                       <Column
                        field="productInfo"
                        header="Product Info"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored6">
                            {rowData.lead?.productInfo}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="queries"
                        header="Operation Remark"
                        style={{ minWidth: '200px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.queries}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="address"
                        header="Address"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.address}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="source"
                        header="Source"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored6">
                            {rowData.lead?.source}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="followUpOn"
                        header="Follow Up On"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => {
                          const followUpDate = rowData?.leadInfoList?.find(
                            item => item.keyName === "nextFollowUpDate"
                          )?.dateValue;


                          return (
                            <span>
                              {followUpDate ? formatDate(followUpDate) : "N/A"}
                            </span>
                          );
                        }
                        }
                      ></Column>

                      {/*<Column
                                                                                                                                       field="status"
                                                                                                                                       header="Status"
                                                                                                                                       style={{ minWidth: '100px' }}
                                                                                                                                       className="product-category table-design"
                                                                                                                                       body={(rowData) => (
                                                                                                                                           <span>
                                                                                                                                               {rowData.lead?.status === "RECEIVE" ? "New Lead" : rowData.lead?.status === "in process" ? "WIP (Less Then 1 Cr)" : rowData.lead?.status === "hold for follow up after sometime" ? "WIP (More Then 1 Cr)" : rowData.lead?.status}
                                                                                                                                           </span>
                                                                                                                                       )}
                                                                                                                                   ></Column>*/}


                      {/*<Column
                                                                                                               field="Doc"
                                                                                                               header="Doc View"
                                                                                                               className="product-category table-design"
                                                                                                               body={(rowData) => (
                                                                                                                 <Link
                                                                                                                   to={"/view-lead-document"}
                                                                                                                   state={rowData?.lead}
                                                                                                                   className="move-btn-medium move-btn-green center-text"
                                                                                                                 >
                                                                                                                   Doc View <i className="bi bi-eye"></i>
                                                                                                                 </Link>
                                                                                                               )}
                                                                                                             ></Column>*/}


                    </DataTable>}
                    <div className="flex justify-content-center gap-2 my-3">
                      {Array.from({ length: pagesBoxField }).map((_, index) => (
                        <Button
                          key={index}
                          label={(index + 1).toString()}
                          onClick={() => handlePageChange(index, defaultPayload)}
                          className={rows === index ? "p-button" : "p-button-outlined"}
                        />
                      ))}
                    </div>
                  </div>
                  <DataScroller
                    ref={ds}
                    value={products}
                    itemTemplate={itemTemplate}
                    rows={5}
                    loader

                  />


                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
